import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Layout from './components/layout/Layout'
import Home from './pages/Home'
import Cinema from './pages/Cinema'
import Library from './pages/Library'
import About from './pages/About'
import { ModalProvider } from './context/ModalContext'

import './App.css'
import Modal from './components/ui/Modal'
import TokenService from './services/api/tokenService'
import NotFound from './pages/NotFound'

export function App() {
  const token = new URLSearchParams(window.location.search).get('token')

  if (token) {
    TokenService.setToken(token)
  }

  return (
    <ModalProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path='/' element={<Home />} index />
            <Route path='hakkinda' element={<About />} />
            <Route path='sinema' element={<Cinema />} />
            <Route path='kutuphane' element={<Library />} />
          </Route>
          <Route path='/*' element={<NotFound />} />
        </Routes>
      </BrowserRouter>
      <Modal />
    </ModalProvider>
  )
}

export default App
